import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 *
 * We use Ably in Pusher compatibility mode — the Pusher Protocol Adapter
 * must be enabled in the Ably application settings.
 */

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
window.Pusher = Pusher;

if (import.meta.env.VITE_ABLY_PUBLIC_KEY) {
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: import.meta.env.VITE_ABLY_PUBLIC_KEY,
        wsHost: 'realtime-pusher.ably.io',
        wsPort: 443,
        wssPort: 443,
        cluster: 'eu', // Required by pusher-js but ignored — Ably routes globally via wsHost
        disableStats: true,
        encrypted: true,
        forceTLS: true,
    });
    window.Pusher.logToConsole = import.meta.env.DEV;
} else {
    console.error('Laravel Echo deactivated. Please set VITE_ABLY_PUBLIC_KEY in .env');
}
